let projectSelect = null;

function initProjectSelect(selector = '#projectSelect') {
	projectSelect = document.querySelector(selector);

	if(!projectSelect){
		projectSelect = document.querySelector('.component-project-select');
	}

	if (selector) {
		projectSelect.onchange = changeProject;
	}
}

function changeProject() {
	const projectId = projectSelect.value;

	loading();
	if (projectId) {

		const url = window.location.toString();

		if (url.includes('project')) {
			let newLocation = url.replace(/project=\d+/, `project=${projectId}`);

			if (newLocation.includes('page')) {
				// Send back to page 1 when changing projects
				newLocation = url.replace(/page=\d+/, '');
			}
			window.location = newLocation;
		} else {
			let newUrl = new URL(window.location);

			newUrl.searchParams.set('project', projectId);
			newUrl.searchParams.delete('all');

			window.location = newUrl;
		}
	} else {
		let newUrl = new URL(window.location);

		newUrl.searchParams.delete('project');
		newUrl.searchParams.set('all', '1');

		window.location = newUrl;
	}
}

export {initProjectSelect}
